//  let qtyInput = document.querySelector('.product-info .quantity-selector__input');
// if(qtyInput){
//   qtyInput.addEventListener('input', function() {
//     let qty = qtyInput.value;
//     doit(qty);
//   });
// }

/* =====================================================================
   DREAM VESSELS — NATIVE WISHLIST ENGINE  (replaces Wishlist Plus / Swym)
   Self-contained. No app, no external requests except Shopify product JSON.
   Storage: localStorage key "dv_wishlist_v1"
   Covers: product cards, product page button, header link, wishlist page.
   Author: Claude build — working copy only until published.
   ===================================================================== */
(function () {
  "use strict";

  var KEY = "dv_wishlist_v1";
  var WISHLIST_URL = "/pages/wishlist";
  var CURRENCY = "USD"; // Dream Vessels store currency

  /* ---------- storage ---------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(items) {
    try { window.localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    broadcast();
  }
  function has(id) {
    id = String(id);
    return read().some(function (it) { return String(it.id) === id; });
  }
  function add(item) {
    var items = read();
    if (!items.some(function (it) { return String(it.id) === String(item.id); })) {
      item.addedAt = Date.now();
      items.unshift(item);
      write(items);
    }
  }
  function remove(id) {
    id = String(id);
    write(read().filter(function (it) { return String(it.id) !== id; }));
  }
  function toggle(item) {
    if (has(item.id)) { remove(item.id); return false; }
    add(item); return true;
  }
  function count() { return read().length; }

  function broadcast() {
    document.dispatchEvent(new CustomEvent("dv:wishlist:change", { detail: { count: count() } }));
  }

  /* ---------- helpers ---------- */
  function handleFromUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return n.toLocaleString(undefined, { style: "currency", currency: CURRENCY });
    } catch (e) { return "$" + n.toFixed(2); }
  }
  function getParam(name) {
    var m = new RegExp("[?&]" + name + "=([^&]+)").exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : null;
  }
  var HEART =
    '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">' +
    '<path class="dv-heart-shape" d="M12 21s-7.5-4.9-10-9.2C.4 8.6 2 5 5.3 5c2 0 3.4 1.2 4.2 2.4C10.3 6.2 11.7 5 13.7 5 17 5 18.6 8.6 17 11.8 14.5 16.1 12 21 12 21z"/></svg>';

  /* ---------- styles (injected so we never touch custom.css) ---------- */
  function injectStyles() {
    if (document.getElementById("dv-wishlist-styles")) return;
    var css =
      /* neutralise leftover Swym markup */
      ".swym-add-to-wishlist-view-product{display:none!important;}" +
      ".swym-wishlist-button-bar,.swym-button-bar,.swym-inject{display:none!important;}" +
      /* card heart */
      ".dv-wishlist-btn{position:absolute;top:10px;right:10px;z-index:4;width:38px;height:38px;display:inline-flex;align-items:center;justify-content:center;padding:0;margin:0;border:none;border-radius:9999px;background:rgba(255,255,255,.9);box-shadow:0 1px 4px rgba(0,0,0,.14);cursor:pointer;color:#4b2813;transition:transform .12s ease,background .12s ease;}" +
      ".dv-wishlist-btn:hover{transform:scale(1.08);background:#fff;}" +
      ".dv-wishlist-btn svg .dv-heart-shape{fill:none;stroke:currentColor;stroke-width:1.7;transition:fill .12s ease;}" +
      ".dv-wishlist-btn.is-saved{color:#c0392b;}" +
      ".dv-wishlist-btn.is-saved svg .dv-heart-shape{fill:currentColor;stroke:currentColor;}" +
      ".dv-wishlist-btn.dv-pop{animation:dvpop .28s ease;}" +
      "@keyframes dvpop{0%{transform:scale(1);}40%{transform:scale(1.28);}100%{transform:scale(1);}}" +
      /* product-page button */
      ".dv-wishlist-pdp-wrap{margin:12px 0 0;}" +
      ".dv-wishlist-pdp{display:inline-flex;align-items:center;justify-content:center;gap:9px;width:100%;padding:12px 16px;border:1.5px solid #4b2813;background:#fff;color:#4b2813;border-radius:8px;font-size:.9rem;letter-spacing:.02em;cursor:pointer;transition:background .15s ease,color .15s ease,opacity .15s ease;}" +
      ".dv-wishlist-pdp:hover{background:#4b2813;color:#fff;}" +
      ".dv-wishlist-pdp[disabled]{opacity:.5;cursor:default;}" +
      ".dv-wishlist-pdp svg{width:18px;height:18px;}" +
      ".dv-wishlist-pdp .dv-heart-shape{fill:none;stroke:currentColor;stroke-width:1.7;transition:fill .12s ease;}" +
      ".dv-wishlist-pdp.is-saved{background:#4b2813;color:#fff;}" +
      ".dv-wishlist-pdp.is-saved .dv-heart-shape{fill:currentColor;stroke:currentColor;}" +
      /* header link */
      ".dv-wishlist-headlink{position:relative;display:inline-flex;align-items:center;justify-content:center;color:inherit;text-decoration:none;}" +
      ".dv-wishlist-headlink .dv-wl-count{position:absolute;top:-6px;right:-8px;min-width:16px;height:16px;padding:0 4px;border-radius:9999px;background:#c0392b;color:#fff;font-size:10px;line-height:16px;text-align:center;font-weight:600;display:none;}" +
      ".dv-wishlist-headlink.has-items .dv-wl-count{display:block;}" +
      /* wishlist page */
      ".dv-wl-wrap{max-width:1200px;margin:0 auto;padding:2rem 1.5rem 4rem;}" +
      ".dv-wl-title{font-size:1.9rem;margin:0 0 .3rem;}" +
      ".dv-wl-sub{color:#6b6b6b;margin:0 0 2rem;font-size:.95rem;}" +
      ".dv-wl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:1.4rem;}" +
      ".dv-wl-card{position:relative;border:1px solid #eee;border-radius:12px;overflow:hidden;background:#fff;display:flex;flex-direction:column;}" +
      ".dv-wl-card a.dv-wl-imglink{display:block;aspect-ratio:1/1;background:#f6f4f1;}" +
      ".dv-wl-card img{width:100%;height:100%;object-fit:cover;display:block;}" +
      ".dv-wl-body{padding:.85rem .95rem 1rem;display:flex;flex-direction:column;gap:.5rem;flex:1;}" +
      ".dv-wl-name{font-size:.98rem;line-height:1.25;color:#222;text-decoration:none;}" +
      ".dv-wl-price{font-weight:600;color:#4b2813;}" +
      ".dv-wl-price .dv-wl-compare{text-decoration:line-through;opacity:.55;font-weight:400;margin-left:6px;}" +
      ".dv-wl-actions{margin-top:auto;display:flex;gap:.5rem;}" +
      ".dv-wl-add{flex:1;border:none;background:#4b2813;color:#fff;border-radius:8px;padding:.6rem .5rem;font-size:.85rem;cursor:pointer;transition:opacity .12s;}" +
      ".dv-wl-add:hover{opacity:.88;}" +
      ".dv-wl-add[disabled]{opacity:.45;cursor:default;}" +
      ".dv-wl-remove{border:1px solid #ddd;background:#fff;color:#555;border-radius:8px;padding:.6rem .7rem;font-size:.85rem;cursor:pointer;}" +
      ".dv-wl-remove:hover{border-color:#c0392b;color:#c0392b;}" +
      ".dv-wl-empty{text-align:center;padding:3rem 1rem;color:#666;}" +
      ".dv-wl-empty a{color:#4b2813;font-weight:600;}" +
      ".dv-wl-loading{color:#999;padding:2rem 0;}";
    var tag = document.createElement("style");
    tag.id = "dv-wishlist-styles";
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  /* ---------- product-card hearts ---------- */
  function buildItemFromSwym(el) {
    var url = el.getAttribute("data-product-url") || "";
    var id = (el.getAttribute("data-product-id") || "").replace(/[^0-9]/g, "");
    if (!id) {
      var cls = (el.className.match(/product_(\d+)/) || [])[1];
      if (cls) id = cls;
    }
    return {
      id: id,
      handle: handleFromUrl(url),
      url: (url.replace(/^https?:\/\/[^/]+/, "") || "") || (handleFromUrl(url) ? "/products/" + handleFromUrl(url) : ""),
      variantId: el.getAttribute("data-variant-id") || null
    };
  }

  function enhanceCards(root) {
    var swymButtons = (root || document).querySelectorAll(".swym-add-to-wishlist-view-product");
    swymButtons.forEach(function (sw) {
      if (sw.dataset.dvDone) return;
      sw.dataset.dvDone = "1";
      var item = buildItemFromSwym(sw);
      if (!item.id) return;

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "dv-wishlist-btn";
      btn.setAttribute("aria-label", "Add to wishlist");
      btn.setAttribute("data-dv-id", item.id);
      btn.innerHTML = HEART;
      if (has(item.id)) { btn.classList.add("is-saved"); btn.setAttribute("aria-pressed", "true"); }
      else { btn.setAttribute("aria-pressed", "false"); }

      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        var nowSaved = toggle(item);
        btn.classList.toggle("is-saved", nowSaved);
        btn.setAttribute("aria-pressed", nowSaved ? "true" : "false");
        if (nowSaved) { btn.classList.remove("dv-pop"); void btn.offsetWidth; btn.classList.add("dv-pop"); }
      });

      (sw.parentNode || sw).insertBefore ? sw.parentNode.insertBefore(btn, sw) : sw.parentNode.appendChild(btn);
    });
  }

  function refreshCardStates() {
    document.querySelectorAll(".dv-wishlist-btn[data-dv-id]").forEach(function (btn) {
      var saved = has(btn.getAttribute("data-dv-id"));
      btn.classList.toggle("is-saved", saved);
      btn.setAttribute("aria-pressed", saved ? "true" : "false");
    });
  }

  /* ---------- product-page button ---------- */
  function injectPdpButton() {
    if (!document.body || document.body.className.indexOf("template-product") === -1) return;
    if (document.querySelector(".dv-wishlist-pdp")) return;

    var buy = document.querySelector(".product-info buy-buttons") ||
              document.querySelector("buy-buttons") ||
              document.querySelector('.product-info__block-item[data-block-type="buy-buttons"]');
    var anchor = buy;
    if (!anchor) {
      anchor = document.querySelector(".product-info product-form") || document.querySelector(".product-info");
    }
    if (!anchor) return;

    var handle = handleFromUrl(window.location.pathname);
    if (!handle) return;

    var wrap = document.createElement("div");
    wrap.className = "dv-wishlist-pdp-wrap";
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "dv-wishlist-pdp";
    btn.disabled = true;
    btn.innerHTML = HEART + '<span class="dv-wishlist-pdp__label">Save to wishlist</span>';
    wrap.appendChild(btn);

    if (anchor.parentNode && anchor.tagName && anchor.tagName.toLowerCase() === "buy-buttons") {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else if (anchor.classList && anchor.classList.contains("product-info__block-item")) {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else {
      anchor.appendChild(wrap);
    }

    fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) { wrap.remove(); return; }
        var variantParam = getParam("variant");
        var variantId = variantParam || (p.variants && p.variants[0] ? p.variants[0].id : null);
        var item = { id: p.id, handle: p.handle, url: p.url, variantId: variantId };
        btn.setAttribute("data-dv-id", String(p.id));
        btn.disabled = false;
        setPdpState(btn, has(p.id));

        btn.addEventListener("click", function () {
          var formVariant = document.querySelector('.product-info [name="id"]');
          if (formVariant && formVariant.value) item.variantId = formVariant.value;
          var nowSaved = toggle(item);
          setPdpState(btn, nowSaved);
        });
      })
      .catch(function () { wrap.remove(); });
  }

  function setPdpState(btn, saved) {
    btn.classList.toggle("is-saved", saved);
    btn.setAttribute("aria-pressed", saved ? "true" : "false");
    var label = btn.querySelector(".dv-wishlist-pdp__label");
    if (label) label.textContent = saved ? "Saved to wishlist" : "Save to wishlist";
  }

  function refreshPdpState() {
    var btn = document.querySelector(".dv-wishlist-pdp[data-dv-id]");
    if (btn) setPdpState(btn, has(btn.getAttribute("data-dv-id")));
  }

  /* ---------- header link ---------- */
  function injectHeaderLink() {
    if (document.querySelector(".dv-wishlist-headlink")) return;
    var cart =
      document.querySelector('a[href$="/cart"]') ||
      document.querySelector('a[href*="/cart"]') ||
      document.querySelector("[data-cart-link]");
    if (!cart) return;
    var link = document.createElement("a");
    link.href = WISHLIST_URL;
    link.className = "dv-wishlist-headlink";
    link.setAttribute("aria-label", "View wishlist");
    link.innerHTML = HEART + '<span class="dv-wl-count">0</span>';
    cart.parentNode.insertBefore(link, cart);
    updateHeaderCount();
  }
  function updateHeaderCount() {
    var link = document.querySelector(".dv-wishlist-headlink");
    if (!link) return;
    var c = count();
    var badge = link.querySelector(".dv-wl-count");
    if (badge) badge.textContent = c;
    link.classList.toggle("has-items", c > 0);
  }

  /* ---------- wishlist page ---------- */
  function renderWishlistPage() {
    var root = document.getElementById("dv-wishlist-root");
    if (!root) return;
    var items = read();
    if (!items.length) {
      root.innerHTML =
        '<div class="dv-wl-empty"><p>Your wishlist is empty — start saving the pieces you love.</p>' +
        '<p><a href="/collections/all">Browse the collection →</a></p></div>';
      return;
    }
    root.innerHTML = '<div class="dv-wl-grid" id="dv-wl-grid"></div>';
    var grid = document.getElementById("dv-wl-grid");

    items.forEach(function (item) {
      var card = document.createElement("div");
      card.className = "dv-wl-card";
      card.setAttribute("data-dv-id", item.id);
      card.innerHTML = '<div class="dv-wl-body"><p class="dv-wl-loading">Loading…</p></div>';
      grid.appendChild(card);

      var handle = item.handle || handleFromUrl(item.url);
      if (!handle) { fillCard(card, item, null); return; }
      fetch("/products/" + handle + ".js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { fillCard(card, item, p); })
        .catch(function () { fillCard(card, item, null); });
    });
  }

  function fillCard(card, item, p) {
    var url = p ? p.url : (item.url || "#");
    var title = p ? p.title : "View product";
    var img = p && p.featured_image ? p.featured_image : (p && p.images && p.images[0]) || "";
    if (img && img.indexOf("//") === 0) img = "https:" + img;
    var priceHtml = "";
    if (p) {
      var price = formatMoney(p.price);
      var compare = (p.compare_at_price && p.compare_at_price > p.price) ? '<span class="dv-wl-compare">' + formatMoney(p.compare_at_price) + "</span>" : "";
      priceHtml = '<div class="dv-wl-price">' + price + compare + "</div>";
    }
    var variantId = (p && p.variants && p.variants[0]) ? p.variants[0].id : item.variantId;
    var available = p ? p.available : true;

    card.innerHTML =
      '<a class="dv-wl-imglink" href="' + url + '">' + (img ? '<img src="' + img + '&width=500" alt="" loading="lazy">' : "") + "</a>" +
      '<div class="dv-wl-body">' +
        '<a class="dv-wl-name" href="' + url + '">' + escapeHtml(title) + "</a>" +
        priceHtml +
        '<div class="dv-wl-actions">' +
          '<button type="button" class="dv-wl-add" data-variant="' + (variantId || "") + '"' + (available && variantId ? "" : " disabled") + ">" + (available ? "Add to cart" : "Sold out") + "</button>" +
          '<button type="button" class="dv-wl-remove" aria-label="Remove">Remove</button>' +
        "</div>" +
      "</div>";

    card.querySelector(".dv-wl-remove").addEventListener("click", function () {
      remove(item.id);
      card.style.transition = "opacity .2s"; card.style.opacity = "0";
      setTimeout(function () { renderWishlistPage(); }, 180);
    });
    var addBtn = card.querySelector(".dv-wl-add");
    if (addBtn && !addBtn.disabled) {
      addBtn.addEventListener("click", function () {
        var vid = addBtn.getAttribute("data-variant");
        if (!vid) return;
        addBtn.disabled = true; addBtn.textContent = "Adding…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        }).then(function (r) { return r.json(); })
          .then(function () {
            addBtn.textContent = "Added ✓";
            document.dispatchEvent(new CustomEvent("dv:cart:added"));
            setTimeout(function () { addBtn.disabled = false; addBtn.textContent = "Add to cart"; }, 1600);
          }).catch(function () { addBtn.disabled = false; addBtn.textContent = "Try again"; });
      });
    }
  }

  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    injectStyles();
    enhanceCards(document);
    injectPdpButton();
    injectHeaderLink();
    renderWishlistPage();

    document.addEventListener("dv:wishlist:change", function () {
      refreshCardStates();
      refreshPdpState();
      updateHeaderCount();
    });
    window.addEventListener("storage", function (e) {
      if (e.key === KEY) { refreshCardStates(); refreshPdpState(); updateHeaderCount(); renderWishlistPage(); }
    });

    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) {
            enhanceCards(document);
            injectPdpButton();
            break;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.DVWishlist = { read: read, add: add, remove: remove, count: count, KEY: KEY };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
})();
